export default "__VITE_PUBLIC_ASSET__65c02e66__"